
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class PDCReceivableGrid extends Serenity.EntityGrid<PDCReceivableRow, any> {
        protected getColumnsKey() { return 'Finance.PDCReceivable'; }
        protected getDialogType() { return PDCReceivableDialog; }
        protected getIdProperty() { return PDCReceivableRow.idProperty; }
        protected getInsertPermission() { return PDCReceivableRow.insertPermission; }
        protected getLocalTextPrefix() { return PDCReceivableRow.localTextPrefix; }
        protected getService() { return PDCReceivableService.baseUrl; }
        constructor(container: JQuery) {
            super(container);
        }

        protected addButtonClick() {

            let now = new Date();
            
            var voucherNo = FormatHelper.GetVoucherNo(8);
            this.editItem(<PDCReceivableRow>{
                VoucherNo: voucherNo,
                TransDate: now.toString(),
                CreatedBy: Q.Authorization.userDefinition.UserId.toString(),
                VoucherTypeId: 8,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                Status:"Not Cleared"

            });
        }
    }
}